import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-token.mjs";
import { render } from "lit-html";
import {
    TREASURY,
    getRandomNumber,
    B,
    getCircle,
    getPublicName,
    getKiitosSummary,
    TOKENS,
    getTipAmount,
    getTipAmount2,
    downloadFile,
    isTip,
    getAuraRing,
    getAuraName
} from "../../global.ts";
import { Token, Tokens } from "../../../models/Thanks.ts";
import { Functions } from "../../../managers/Functions.ts";
import { Me } from "../../../managers/Me.ts";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbMain } from "../hb-main.ts";
//import Hammer from "hammerjs";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

import Stock from "./Treasury.json";
const stock: { category: string; folder: string; count: number }[] = Stock;

export class HbToken extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private me = new Me();
    private media = new Media();
    private tokens = new Tokens();
    private functions = new Functions();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private jewelry: HTMLElement;
    private form: HTMLFormElement;
    private archive: HTMLButtonElement;
    private cover: HTMLVideoElement;
    private date: HTMLSpanElement;
    private views: HTMLSpanElement;

    private heartTitle: HTMLSelectElement;
    private heartMenu: HTMLSpanElement;
    private heartLabel: HTMLSpanElement;

    private anonymousContainer: HTMLElement;
    private publicBtn: HTMLButtonElement;
    private anonymousBtn: HTMLButtonElement;
    private anonymous: HTMLSpanElement;
    private from: HTMLSpanElement;
    private to: HTMLSpanElement;

    private internalBtns: HTMLElement;
    private thankBtn: HTMLButtonElement; // thank sender
    private rethankBtn: HTMLButtonElement; // rethank recipient
    private thankallBtn: HTMLButtonElement; // thank both
    private giveBtn: HTMLButtonElement;
    private externalBtns: HTMLElement;
    private shareBtn: HTMLButtonElement;
    private copyBtn: HTMLButtonElement;
    private tokenBtns: HTMLElement;

    private menu: HTMLElement;
    private pager: HTMLElement;
    private page: HTMLElement;
    private previous: HTMLButtonElement;
    private next: HTMLButtonElement;

    private photo: HTMLElement;
    private photoBtn: HTMLButtonElement;
    private photoFile: HTMLInputElement;
    private photoProgress: HTMLElement;
    private photoUpload: HTMLElement;
    private photoImageContainer: HTMLElement;
    private photoImage: HTMLImageElement;
    private photoRemove: HTMLButtonElement;
    private photoDownload: HTMLButtonElement;

    private short: HTMLElement;
    private shortBtn: HTMLButtonElement;
    private shortFile: HTMLInputElement;
    private shortProgress: HTMLElement;
    private shortUpload: HTMLElement;
    private shortVideoContainer: HTMLElement;
    private shortVideo: HTMLVideoElement;
    private shortRemove: HTMLButtonElement;
    private shortDownload: HTMLButtonElement;

    private stock: HTMLElement;
    private stockBtn: HTMLButtonElement;
    private stockImage: HTMLImageElement;

    private ai: HTMLElement;
    private aiBtn: HTMLButtonElement;
    private prompt: HTMLInputElement;
    private promptBtn: HTMLButtonElement;
    private aiImage: HTMLImageElement;

    private gold: HTMLTextAreaElement;
    private goldMenu: HTMLLabelElement;
    private goldLabel: HTMLLabelElement;
    private goldKarat: HTMLSpanElement;
    private goldCarat: HTMLSpanElement;
    private goldKiitos: HTMLSpanElement;
    private goldGratuity: HTMLSpanElement;
    private magic: HTMLButtonElement;
    private paste: HTMLButtonElement;
    private trash: HTMLButtonElement;

    private footer: HTMLElement;
    private footerDate: HTMLParagraphElement;
    private rethanks: HTMLSpanElement;

    private stockCategory = stock[0].folder;
    private stockItem = getRandomNumber(1, stock[0].count);
    private stockCount = stock[0].count;

    private aiItem = 0;
    private aiCount = 0;

    private hasPasskey = false;
    private thank: Token | null = null;
    private jewel: "photo" | "short" | "ai" | "stock" = "stock";

    private toUID = "";
    private isAnonymous = false;
    private token = "";
    private isBank = false;
    private isGram = false; // for create new token button
    private isChest = false;
    private isLoading = false;
    private lastTapTime: number = 0;

    private readonly rainbow = [
        "red",
        "orange",
        "yellow",
        "green",
        "blue",
        "indigo",
        "violet"
    ];

    constructor() {
        super();
        render(template(null), this);

        this.jewelry = this.querySelector("#hb-token")!;
        this.form = this.querySelector("#hb-token-form")!;
        this.archive = this.querySelector("#hb-token-archive")!;
        this.cover = this.querySelector("#hb-token-cover")!;
        this.date = this.querySelector("#hb-token-date")!;
        this.views = this.querySelector("#hb-token-views")!;

        this.heartTitle = this.querySelector("#hb-token-heart-title")!;
        this.heartMenu = this.querySelector("#hb-token-heart-menu")!;
        this.heartLabel = this.querySelector("#hb-token-heart-label")!;

        this.anonymousContainer = this.querySelector("#hb-token-anonymous")!;
        this.anonymousBtn = this.querySelector("#hb-token-anonymous-true")!;
        this.publicBtn = this.querySelector("#hb-token-anonymous-false")!;
        this.anonymous = this.querySelector("#hb-token-party-anonymous")!;
        this.from = this.querySelector("#hb-token-party-from")!;
        this.to = this.querySelector("#hb-token-party-to")!;

        this.internalBtns = this.querySelector("#hb-token-internal")!;
        this.thankBtn = this.internalBtns
            .firstElementChild as HTMLButtonElement;
        this.rethankBtn = this.querySelector("#hb-token-rethank")!;
        this.thankallBtn = this.querySelector("#hb-token-thankall")!;
        this.giveBtn = this.internalBtns.lastElementChild as HTMLButtonElement;
        this.externalBtns = this.querySelector("#hb-token-external")!;
        this.shareBtn = this.querySelector("#hb-token-share")!;
        this.copyBtn = this.querySelector("#hb-token-copy")!;
        this.tokenBtns = this.querySelector("#hb-token-tokens")!;

        this.menu = this.querySelector("#hb-token-menu")!;
        this.pager = this.querySelector("#hb-token-menu-pager")!;
        this.page = this.querySelector("#hb-token-menu-page")!;
        this.previous = this.querySelector("#hb-token-menu-previous")!;
        this.next = this.querySelector("#hb-token-menu-next")!;

        this.photo = this.querySelector("#hb-token-photo")!;
        this.photoBtn = this.querySelector("#hb-token-menu-photo")!;
        this.photoFile = this.querySelector("#hb-token-photo-file")!;
        this.photoProgress = this.querySelector("#hb-token-photo-progress")!;
        this.photoUpload = this.querySelector("#hb-token-photo-upload")!;
        this.photoImage = this.querySelector("#hb-token-photo-image")!;
        this.photoRemove = this.querySelector("#hb-token-photo-remove")!;
        this.photoImageContainer = this.photoImage.parentElement as HTMLElement;
        this.photoDownload = this.querySelector("#hb-token-photo-download")!;

        this.short = this.querySelector("#hb-token-short")!;
        this.shortBtn = this.querySelector("#hb-token-menu-short")!;
        this.shortFile = this.querySelector("#hb-token-short-file")!;
        this.shortProgress = this.querySelector("#hb-token-short-progress")!;
        this.shortUpload = this.querySelector("#hb-token-short-upload")!;
        this.shortVideo = this.querySelector("#hb-token-short-video")!;
        this.shortRemove = this.querySelector("#hb-token-short-remove")!;
        this.shortVideoContainer = this.shortVideo.parentElement as HTMLElement;
        this.shortDownload = this.querySelector("#hb-token-short-download")!;

        this.stock = this.querySelector("#hb-token-stock")!;
        this.stockBtn = this.querySelector("#hb-token-menu-stock")!;
        this.stockImage = this.querySelector("#hb-token-stock-image")!;

        this.ai = this.querySelector("#hb-token-ai")!;
        this.aiBtn = this.querySelector("#hb-token-menu-ai")!;
        this.prompt = this.querySelector("#hb-token-ai-prompt")!;
        this.promptBtn = this.querySelector("#hb-token-ai-magic")!;
        this.aiImage = this.querySelector("#hb-token-ai-image")!;

        this.gold = this.querySelector("#hb-token-gold")!;
        this.goldMenu = this.querySelector("#hb-token-gold-menu")!;
        this.goldLabel = this.querySelector("#hb-token-gold-label")!;
        this.goldKarat = this.querySelector("#hb-token-gold-karat")!;
        this.goldCarat = this.querySelector("#hb-token-gold-carat")!;
        this.goldKiitos = this.querySelector("#hb-token-gold-kiitos")!;
        this.goldGratuity = this.querySelector("#hb-token-gold-gratuity")!;
        this.magic = this.querySelector("#hb-token-gold-magic")!;
        this.paste = this.querySelector("#hb-token-gold-paste")!;
        this.trash = this.querySelector("#hb-token-gold-trash")!;

        this.footer = this.querySelector("#hb-token-footer")!;
        this.footerDate = this.querySelector("#hb-token-footer-date")!;
        this.rethanks = this.querySelector("#hb-token-footer-rethanks")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: false,
            onHide: () => {
                this.cover.muted = true;
                this.shortVideo.muted = true;
                //window.location.hash = "#";
            },
            onShow: () => {
                // need user interaction
                //if (this.stockImage.paused) this.stockImage.play();
                //if (this.aiImage.paused) this.aiImage.play();
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-token",
            override: true
        };

        this.modal = new Modal(this.jewelry, modalOptions, instanceOptions);
    }

    private addDoubleTapListener() {
        const el = this.cover.parentElement as HTMLElement;
        if (!el) return;

        el.addEventListener("touchend", (e: TouchEvent) => {
            const currentTime = new Date().getTime();
            const tapDelay = currentTime - this.lastTapTime;

            // 300ms is the standard threshold for a double tap
            if (tapDelay < 300 && tapDelay > 0) {
                this.handleDoubleTap(e);
            }

            this.lastTapTime = currentTime;
        });
    }

    private addSwipeListeners() {
        const el = this.cover.parentElement as HTMLElement;
        if (!el) return;

        let touchStartX = 0;
        let touchEndX = 0;

        // 1. Capture the start of the touch
        el.addEventListener(
            "touchstart",
            (e: TouchEvent) => {
                touchStartX = e.changedTouches[0].screenX;
            },
            { passive: true }
        );

        // 2. Capture the end and calculate the delta
        el.addEventListener(
            "touchend",
            (e: TouchEvent) => {
                touchEndX = e.changedTouches[0].screenX;
                this.handleSwipeGesture(touchStartX, touchEndX);
            },
            { passive: true }
        );
    }

    private showLoading(isLoading: boolean) {
        if (isLoading) {
            this.isLoading = true;
            this.main.showSpinner();
        } else {
            this.isLoading = false;
            this.main.hideSpinner();
        }
    }

    private async handleDoubleTap(e: TouchEvent) {
        const el = e.currentTarget as HTMLElement;
        const rect = el.getBoundingClientRect();
        const touchX = e.changedTouches[0].clientX - rect.left; // X position relative to element
        const midPoint = rect.width / 2;

        if (touchX > midPoint) {
            console.log("Double tapped on the RIGHT");
        } else {
            console.log("Double tapped on the LEFT");
        }

        if (this.isLoading || !this.thank) return;
        this.showLoading(true);
        const token = this.isGram
            ? await this.tokens.getRandomGram(this.thank.from!, this.thank.to)
            : await this.tokens.getRandom(
                  this.isChest ? "" : this.heartbank.user?.uid || ""
              );
        this.showLoading(false);

        if (token) {
            history.pushState(
                null,
                "",
                `#/token/${token.id}${this.isGram ? "/gram" : this.isChest ? "/chest" : ""}`
            );
            await this.show(
                token,
                this.isGram ? "gram" : this.isChest ? "chest" : "",
                "0",
                false
            );
            //window.location.hash = `#/token/${token.id}${this.isGram ? "/gram" : this.isChest ? "/chest" : ""}`;
        } else alert("There are no more B-Tokens of Appreciation");
    }

    private async handleSwipeGesture(startX: number, endX: number) {
        const threshold = 50; // Minimum pixels to count as a swipe
        const delta = endX - startX;

        // If movement is too small, ignore it
        if (this.isLoading || !this.thank || Math.abs(delta) < threshold)
            return;

        // Swipe Right (Positive delta) vs Swipe Left (Negative delta)
        const direction = delta > 0 ? "next" : "prev";

        this.showLoading(true);
        const token = this.isGram
            ? await this.tokens.getGram(
                  this.thank.from!,
                  this.thank.to,
                  window.tokenCursor,
                  direction
              )
            : await this.tokens.getChest(
                  this.isChest ? "" : this.heartbank.user?.uid || "",
                  window.tokenCursor,
                  direction
              );

        if (token.cursor) window.tokenCursor = token.cursor;
        this.showLoading(false);

        if (token.data) {
            history.pushState(
                null,
                "",
                `#/token/${token.data.id}${this.isGram ? "/gram" : this.isChest ? "/chest" : ""}`
            );
            await this.show(
                token.data,
                this.isGram ? "gram" : this.isChest ? "chest" : "",
                "0",
                false
            );
            //window.location.hash = `#/token/${token.data.id}${this.isGram ? "/gram" : this.isChest ? "/chest" : ""}`;
        } else {
            // const label = direction === "prev" ? "New" : "Old";
            // alert(
            //     `There are no more ${label} B-Tokens between this Nearby Pair`
            // );
            alert("You have reached the end");
        }
    }

    // hammerjs doesn't work in production
    // private addSwipeListeners2() {
    //     const cover = new Hammer(this.cover.parentElement as HTMLElement);

    //     // conflicts with video controls
    //     // cover.on("tap", (ev: HammerInput) => {
    //     //     alert(
    //     //         "Swipe right or left to go to the next or previous B-Token of Appreciation"
    //     //     );
    //     // });

    //     cover.on("swipeleft swiperight", async (ev: HammerInput) => {
    //         this.showLoading(true);
    //         const token = await this.tokens.getGram(
    //             this.thank?.from!,
    //             this.thank?.to!,
    //             window.tokenCursor,
    //             ev.type === "swipeleft" ? "next" : "prev"
    //         );
    //         if (token.cursor) window.tokenCursor = token.cursor;
    //         this.showLoading(false);

    //         if (token.data)
    //             window.location.hash =
    //                 `#/token/${token.data.id}` +
    //                 (this.isChest ? "/chest" : "");
    //         else
    //             alert(
    //                 `There are no more ${ev.type === "swipeleft" ? "New" : "Old"} B-Tokens between this Nearby Pair`
    //             );
    //     });
    // }

    connectedCallback() {
        //this.renderStock();
        this.addPhotoListeners();
        this.addShortListeners();
        this.addStockListeners();
        this.addAIListeners();
        this.addGoldListeners();
        this.addFooterListeners();
        this.addDoubleTapListener();
        this.addSwipeListeners();

        this.heartTitle.addEventListener("click", () => {
            if (this.thank)
                window.open("https://youtu.be/rmtNCo8zqlw", "_blank");
        });
        this.heartTitle.addEventListener("change", () => {
            this.token = this.heartTitle.value;
            this.heartMenu.textContent = this.getHeart(this.heartTitle.value);
            //this.heartLabel.textContent = this.getHeart(this.heartTitle.value);
        });

        this.date.addEventListener("click", () =>
            alert(
                "💛 This B-Token of Appreciation was given nearby on " +
                    this.thank?.date?.toDate().toFormattedString()
            )
        );

        this.archive.addEventListener("click", () =>
            alert("B-Treasury coming soon!")
        );

        this.previous.addEventListener("click", () => {
            this.goToStock(false);
        });

        this.next.addEventListener("click", () => {
            this.goToStock(true);
        });

        this.anonymous.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(
                this.thank?.from || this.heartbank.user?.uid!
            );
            const [sign, karat] = profile.kiitos?.numberTuple() || ["", "Zero"];
            alert(
                `${getAuraRing(profile.kiitosFrequency || 0, true)} Someone's current Kiitos Aura is ${getAuraName(profile.kiitosFrequency || 0)}\n\n${getCircle(
                    profile.kiitos || 0,
                    true
                )} Someone's current Kiitos Balance is ${sign + karat} ${getKiitosSummary(
                    profile.kiitos || 0,
                    "Someone"
                )}`
            );
        });

        this.from.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(
                this.thank?.from || this.heartbank.user?.uid!
            );
            const name = this.me.getName2(profile);
            const [sign, karat] = profile.kiitos?.numberTuple() || ["", "Zero"];
            if (
                confirm(
                    `${getAuraRing(profile.kiitosFrequency || 0, true)} ${name}'s current Kiitos Aura is ${getAuraName(profile.kiitosFrequency || 0)}\n\n${getCircle(profile.kiitos || 0, true)} ${name}'s current Kiitos Balance is ${sign + karat} ${getKiitosSummary(
                        profile.kiitos || 0,
                        name
                    )}\n\nWould you like to watch ${name}'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.to.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(
                this.thank?.to || this.toUID
            );
            const name = this.me.getName2(profile);
            const [sign, karat] = profile.kiitos?.numberTuple() || ["", "Zero"];
            if (
                confirm(
                    `${getAuraRing(profile.kiitosFrequency || 0, true)} ${name}'s current Kiitos Aura is ${getAuraName(profile.kiitosFrequency || 0)}\n\n${getCircle(profile.kiitos || 0, true)} ${name}'s current Kiitos Balance is ${sign + karat} ${getKiitosSummary(
                        profile.kiitos || 0,
                        name
                    )}\n\nWould you like to watch ${name}'s B-Shorts?`
                )
            )
                window.open("https://id.333.eco", "_blank");
        });

        this.anonymousBtn.addEventListener("click", () => {
            this.isAnonymous = true;
            this.anonymous.classList.remove("hidden");
            this.from.classList.add("hidden");

            this.anonymousBtn.classList.add("underline", "uppercase");
            this.publicBtn.classList.remove("underline", "uppercase");
        });

        this.publicBtn.addEventListener("click", () => {
            this.isAnonymous = false;
            this.anonymous.classList.add("hidden");
            this.from.classList.remove("hidden");

            this.anonymousBtn.classList.remove("underline", "uppercase");
            this.publicBtn.classList.add("underline", "uppercase");
        });

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user), this);
            if (user)
                this.hasPasskey = (await this.heartbank.passKeysCount()) > 0;
        });

        // const close = this.querySelector(
        //     "#hb-token-close"
        // ) as HTMLButtonElement;
        // close.addEventListener("click", () => (window.location.hash = "#"));
    }

    private resetMenu() {
        this.photoBtn.classList.remove("underline", "uppercase");
        this.shortBtn.classList.remove("underline", "uppercase");
        this.aiBtn.classList.remove("underline", "uppercase");
        this.stockBtn.classList.remove("underline", "uppercase");

        this.photo.classList.add("hidden");
        this.short.classList.add("hidden");
        this.ai.classList.add("hidden");
        this.stock.classList.add("hidden");

        this.pager.classList.add("hidden");
        this.pager.classList.remove("inline-flex");
    }

    private addPhotoListeners() {
        this.photoBtn.addEventListener("click", () => {
            this.jewel = "photo";
            this.resetMenu();
            this.photoBtn.classList.add("underline", "uppercase");
            this.photo.classList.remove("hidden");
        });

        this.photoFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.showLoading(true);
                this.photoFile.disabled = true;
                if (this.photoFile.files && this.photoFile.files.length > 0) {
                    const progress = this.photoProgress
                        .parentElement as HTMLElement;
                    this.photoProgress.style.width = "0%";
                    this.photoProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const photo = await this.media.createPhotoFromFile(
                            this.photoFile.files[0]
                        );
                        this.photoImage.src = await this.media.storeFile(
                            photo.name,
                            photo,
                            (percent) => {
                                this.photoProgress.style.width = percent + "%";
                                this.photoProgress.textContent = `${percent}%`; // Uploading:
                            }
                        );
                        localStorage.setItem(
                            "token-photo",
                            this.photoImage.src
                        );
                        this.photoImageContainer.classList.remove("hidden");
                        this.photoUpload.classList.add("hidden");
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.photoFile.disabled = false;
                this.showLoading(false);
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to give a B-Token of Appreciation.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to give a B-Token of Appreciation.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.photoDownload.addEventListener("click", async () => {
            this.photoDownload.disabled = true;
            await downloadFile("B-Photo", this.photoImage.src); // extension auto added
            this.photoDownload.disabled = false;
        });

        this.photoRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this photo?")) {
                this.showLoading(true);
                this.photoRemove.disabled = true;

                await this.media.removeFile(this.photoImage.src);
                localStorage.removeItem("token-photo");
                this.photoFile.value = "";
                this.photoImageContainer.classList.add("hidden");
                this.photoUpload.classList.remove("hidden");

                this.photoRemove.disabled = false;
                this.showLoading(false);
            }
        });
    }

    private addShortListeners() {
        this.shortBtn.addEventListener("click", () => {
            this.jewel = "short";
            this.resetMenu();
            this.shortBtn.classList.add("underline", "uppercase");
            this.short.classList.remove("hidden");
        });

        this.shortFile.addEventListener("change", async () => {
            if (this.heartbank.user && this.hasPasskey) {
                this.showLoading(true);
                this.shortFile.disabled = true;
                if (this.shortFile.files && this.shortFile.files.length > 0) {
                    const progress = this.shortProgress
                        .parentElement as HTMLElement;
                    this.shortProgress.style.width = "0%";
                    this.shortProgress.textContent = "0%";
                    progress.classList.remove("hidden");
                    try {
                        const short = this.shortFile.files[0];
                        const result =
                            await this.media.validateVideoFile(short);
                        if (result.isValid && result.poster) {
                            this.shortVideo.poster = await this.media.storeFile(
                                result.poster.name,
                                result.poster,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading poster:
                                }
                            );
                            localStorage.setItem(
                                "token-poster",
                                this.shortVideo.poster
                            );
                            this.shortVideo.src = await this.media.storeFile(
                                short.name,
                                short,
                                (percent) => {
                                    this.shortProgress.style.width =
                                        percent + "%";
                                    this.shortProgress.textContent = `${percent}%`; // Uploading video:
                                }
                            );
                            localStorage.setItem(
                                "token-short",
                                this.shortVideo.src
                            );
                            this.shortVideoContainer.classList.remove("hidden");
                            this.shortUpload.classList.add("hidden");
                        } else alert(result.errorMessage);
                    } catch (error: any) {
                        alert(error.message);
                    } finally {
                        progress.classList.add("hidden");
                    }
                }
                this.shortFile.disabled = false;
                this.showLoading(false);
            } else {
                if (this.heartbank.user) {
                    if (
                        confirm(
                            "Passkey is required to give a B-Token of Appreciation.\n\nWould you like to create one now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-lockbox",
                            window.location.hash
                        );
                        window.location.hash = "#/lockbox";
                    }
                } else {
                    if (
                        confirm(
                            "You need to be logged in to give a B-Token of Appreciation.\n\nWould you like to log in now?"
                        )
                    ) {
                        localStorage.setItem(
                            "redirect-login",
                            window.location.hash
                        );
                        window.location.hash = "#/login";
                    }
                }
            }
        });

        this.shortDownload.addEventListener("click", async () => {
            this.shortDownload.disabled = true;
            await downloadFile("B-Short", this.shortVideo.src); // extension auto added
            this.shortDownload.disabled = false;
        });

        this.shortRemove.addEventListener("click", async () => {
            if (confirm("Would you like to remove this short?")) {
                this.showLoading(true);
                this.shortRemove.disabled = true;

                await this.media.removeFile(this.shortVideo.poster);
                await this.media.removeFile(this.shortVideo.src);
                localStorage.removeItem("token-poster");
                localStorage.removeItem("token-short");
                this.shortFile.value = "";
                this.shortVideoContainer.classList.add("hidden");
                this.shortUpload.classList.remove("hidden");

                this.shortRemove.disabled = false;
                this.showLoading(false);
            }
        });
    }

    private addStockListeners() {
        this.stockBtn.addEventListener("click", () => {
            this.jewel = "stock";
            this.resetMenu();
            this.stockBtn.classList.add("underline", "uppercase");
            this.stock.classList.remove("hidden");
            this.pager.classList.remove("hidden");
            this.pager.classList.add("inline-flex");
        });
    }

    private addAIListeners() {
        this.aiBtn.addEventListener("click", () => {
            this.jewel = "ai";
            this.resetMenu();
            this.aiBtn.classList.add("underline", "uppercase");
            this.ai.classList.remove("hidden");
            //this.menu.classList.remove("hidden");
            //this.pager.classList.add("inline-flex");
            //this.prompt.focus();
        });
    }

    private addGoldListeners() {
        this.gold.addEventListener("input", () => {
            localStorage.setItem("token-gold", this.gold.value);
        });

        this.magic.addEventListener("click", async () => {
            const profile = await this.me.getUserProfile(this.toUID);
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    `Would you like Miss Aquarius™ AI to compose a Thank You Note for ${this.me.getName2(
                        profile
                    )} on your behalf?`
                )
            ) {
                const name = this.isAnonymous
                    ? "Someone nearby"
                    : getPublicName() || "Someone nearby";
                this.gold.value = `${name} would like to thank you!`;
                localStorage.setItem("token-gold", this.gold.value);
                this.gold.focus();
            }
            //alert("AI writing assistant coming soon...");
        });

        this.paste.addEventListener("click", async () => {
            if (
                this.gold.value.trim() === "" ||
                confirm(
                    "Would you like to replace this Thank You Note with the one you copied to your clipboard?"
                )
            ) {
                this.gold.value = await navigator.clipboard.readText();
                localStorage.setItem("token-gold", this.gold.value);
                this.gold.focus();
            }
        });

        this.trash.addEventListener("click", () => {
            if (
                this.gold.value &&
                confirm(
                    "Would you like to clear this Thank You Note and start over?"
                )
            ) {
                this.gold.value = "";
                localStorage.setItem("token-gold", this.gold.value);
                this.gold.focus();
            }
        });
    }

    private getJewel() {
        switch (this.jewel) {
            case "photo":
                return this.photoImage.src || this.stockImage.src;
            case "short":
                return this.shortVideo.poster || this.stockImage.src;
            case "ai":
                return this.stockImage.src; // this.aiImage.src;
            case "stock":
                return this.stockImage.src;
        }
    }

    private getDiamond() {
        switch (this.jewel) {
            case "photo":
                return "";
            case "short":
                return this.shortVideo.src;
            case "ai":
                return "";
            case "stock":
                return "";
        }
    }

    private getType() {
        switch (this.jewel) {
            case "photo":
                return localStorage.getItem("token-photo") ? "photo" : "stock";
            case "short":
                return localStorage.getItem("token-short") ? "short" : "stock"; // check token-poster ?
            case "ai":
                return "stock";
            case "stock":
                return "stock";
        }
    }

    private async cleanUp() {
        const photo = localStorage.getItem("token-photo");
        const poster = localStorage.getItem("token-poster");
        const short = localStorage.getItem("token-short");

        switch (this.jewel) {
            case "photo":
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "short":
                if (photo) await this.media.removeFile(photo);
                break;
            case "ai":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
            case "stock":
                if (photo) await this.media.removeFile(photo);
                if (poster) await this.media.removeFile(poster);
                if (short) await this.media.removeFile(short);
                break;
        }

        localStorage.removeItem("token-photo");
        localStorage.removeItem("token-poster");
        localStorage.removeItem("token-short");
        localStorage.removeItem("token-gold");

        this.photoImageContainer.classList.add("hidden");
        this.photoUpload.classList.remove("hidden");
        this.shortVideoContainer.classList.add("hidden");
        this.shortUpload.classList.remove("hidden");
    }

    private addFooterListeners() {
        this.giveBtn.addEventListener("click", async () => {
            if (this.thank) {
                if (
                    this.isChest &&
                    this.heartbank.user?.uid !== this.thank.from
                ) {
                    window.location.hash = `#/token/yellow/${this.thank.from}/0/0`;
                } else {
                    const event = new CustomEvent("hb-treasury", {
                        detail: {
                            isShow: true
                        },
                        bubbles: true,
                        composed: true
                    });
                    this.dispatchEvent(event);
                    window.location.hash = "#";
                }
            } else {
                this.showLoading(true);
                this.giveBtn.disabled = true;
                if (this.heartbank.user && this.hasPasskey) {
                    const profile = await this.me.getUserProfile(this.toUID);
                    const isRequired = this.isBank && isTip();
                    const tip = getTipAmount(
                        "tip",
                        isRequired,
                        false,
                        this.isAnonymous,
                        profile,
                        this.me.getName2(profile),
                        this.token,
                        this.gold.value.split(" ").length, //undefined,
                        false,
                        this.isBank ? false : !isTip()
                    );

                    if (!isRequired || tip > 0) {
                        const response = await this.tokens.give(
                            this.toUID,
                            this.isAnonymous,
                            this.token,
                            this.gold.value.trim(),
                            this.getJewel(),
                            this.getDiamond(),
                            this.shortVideo.duration || 0,
                            this.getType(),
                            tip
                        );
                        if (response.data) {
                            await this.cleanUp();
                            await this.functions.push(response.data.id!);
                            this.thank = response.data;
                            await this.alertSuccess(
                                "",
                                //response.data.isAnonymous,
                                false,
                                //response.data.kiitos!,
                                response.data.fromBalance || 0,
                                response.data.toBalance || 0
                                //response.data.tip,
                                //response.data.pool!
                            );

                            const event = new CustomEvent("hb-treasury", {
                                detail: {
                                    isShow: false
                                },
                                bubbles: true,
                                composed: true
                            });
                            this.dispatchEvent(event);

                            window.location.hash = `#/token/${response.data.id}`;
                        } else if (response.color === "red")
                            alert(response.text);
                    }
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                "Passkey is required to mint a B-Token of Appreciation.\n\nWould you like to create one now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                "You need to be logged in to mint a B-Token of Appreciation.\n\nWould you like to log in now?"
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        }
                    }
                }
                this.giveBtn.disabled = false;
                this.showLoading(false);
            }
        });

        //this.form.addEventListener("submit", this.share.bind(this));
        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.copyBtn.addEventListener("click", async (event) => {
            try {
                // We wrap the async call in a Promise that returns a Blob
                const clipboardItem = new ClipboardItem({
                    "text/plain": this.getText(false).then((text) => {
                        return new Blob([text], { type: "text/plain" });
                    })
                });

                // We write the item immediately.
                // The browser handles the "waiting" for the getText() promise internally.
                await navigator.clipboard.write([clipboardItem]);

                alert(
                    "This B-Token of Appreciation has been copied to your clipboard!"
                );
            } catch (err) {
                console.error("Clipboard move failed:", err);
                // Fallback for older browsers or permission denials
                alert(
                    "Copy failed. Please try again or ensure the site has clipboard permissions."
                );
            }
        });

        // this.copyBtn.addEventListener("click", async (event) => {
        //     await navigator.clipboard.writeText(await this.getText(false)); // cannot do link first bc weird bug
        //     alert(
        //         "This B-Token of Appreciation has been copied to your clipboard!"
        //     );
        // });

        this.thankBtn.addEventListener("click", async () => {
            await this.renderTokens(this.thank?.from!, true);
            this.externalBtns.classList.add("hidden");
            this.internalBtns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            //this.rethankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });

        this.rethankBtn.addEventListener("click", async () => {
            await this.renderTokens(this.thank?.to!, false);
            this.externalBtns.classList.add("hidden");
            this.internalBtns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            //this.rethankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });

        this.thankallBtn.addEventListener("click", async () => {
            await this.renderTokens(this.thank?.from!, null);
            this.externalBtns.classList.add("hidden");
            this.internalBtns.classList.add("hidden");
            this.tokenBtns.classList.remove("hidden");
            //this.thankBtn.classList.add("hidden");
            //this.rethankBtn.classList.add("hidden");
            this.jewelry.scrollTo({
                top: this.jewelry.scrollHeight,
                behavior: "smooth"
            });
        });
    }

    //TODO: if too slow: do fromName and toName at server like b-thank
    private async alertSuccess(
        thanker: string, // uid or "" // sender or receiver
        //isAnonymous: boolean,
        isReThank: boolean,
        //kiitos: number,
        fromBalance: number,
        toBalance: number,
        //tip: number,
        //pool: number,
        thankerBalance?: number // both
    ) {
        const [fromSign, fromKarat] = fromBalance.numberTuple() || ["", "Zero"];
        const [toSign, toKarat] = toBalance.numberTuple() || ["", "Zero"];
        const [thankerSign, thankerKarat] = thankerBalance?.numberTuple() || [
            "",
            "Zero"
        ];

        const fromName0 = await this.me.getName3(this.thank?.from!);
        const toName0 = await this.me.getName3(this.thank?.to!);

        const toName =
            thanker && this.thank?.isAnonymous
                ? "Anonymous Thanker"
                : await this.me.getName3(thanker || this.thank?.to!); //this.toUID
        const thankerName = this.thank?.isAnonymous
            ? "Anonymous Thanker"
            : fromName0;
        const toNames =
            thankerBalance === undefined
                ? ""
                : this.thank?.isAnonymous
                  ? `Anonymous Thanker and ${toName0}`
                  : `${fromName0} and ${toName0}`;

        const total =
            (this.thank?.tip || 0) +
            (this.thank?.jar || 0) +
            (this.thank?.kitty || 0) +
            (this.thank?.pool || 0);
        const gratuity = total
            ? `and ${thanker ? "donated" : "tipped"} ${total.toCashAmount3()} to ${toNames || toName}`
            : `to ${toNames || toName}`;
        const tip = this.thank?.tip
            ? `\n\n🧧 ${toName0}'s Personal B-Account received ${this.thank.tip.toCashAmount3()}`
            : "";
        const jar = this.thank?.jar
            ? `\n\n💰 ${toName0}'s Retip B-Fund collected ${this.thank.jar.toCashAmount3()}`
            : "";
        const kitty = this.thank?.kitty
            ? `\n\n💰 ${thankerName}'s Retip B-Fund collected ${this.thank.kitty.toCashAmount3()}`
            : "";
        const pool = this.thank?.pool
            ? `\n\n♒️ Your Family B-Kitty collected ${this.thank.pool.toCashAmount3()}`
            : "";

        const balance = toNames
            ? `\n\n${getCircle(
                  thankerBalance!,
                  true
              )} ${thankerName}'s New Kiitos Balance is ${thankerSign + thankerKarat} ${getKiitosSummary(
                  thankerBalance!,
                  thankerName
              )}`
            : "";

        alert(
            `🎉 You have ${
                this.thank?.isAnonymous ? "anonymously" : "successfully"
            } ${isReThank ? "re-given" : "given"} ${this.thank?.kiitos} Kiitos ${gratuity} as a B-Appreciation!${tip + jar + kitty + pool}\n\n🌎 ${toNames ? "Their" : toName + "'s"} kindness is now published on the Aquarius™ Blockchain and broadcasted to inspire the world!\n\n${getCircle(
                fromBalance,
                true
            )} Your New Kiitos Balance is ${fromSign + fromKarat} ${getKiitosSummary(
                fromBalance
            )}${balance}\n\n${getCircle(
                toBalance,
                true
            )} ${toName}'s New Kiitos Balance is ${toSign + toKarat} ${getKiitosSummary(
                toBalance,
                toName
            )}\n\n${this.aquarius(fromBalance)}`
        );
    }

    private aquarius(balance: number) {
        if (balance === 0)
            return "😇 By returning back to Zero, your Aura Color has grown!\n\n♒️ To grow it further, continue to give B-Tokens to people nearby who have touched your heart, and broadcast your location for nearby Zero Heroes to give B-Tokens to you in gratitude.";
        else if (balance < 0)
            return "♒️ Please carry your gratitude forward by showing kindness to people nearby to earn their B-Tokens and return back to Zero!";
        else
            return "♒️ Please carry the gratitude that people nearby have shown to you forward by giving B-Tokens of Appreciation to return back to Zero!";
    }

    private getCarat() {
        switch (this.thank?.type) {
            case "photo":
                return "Photo";
            case "short":
                return `Short lasting ${Math.round(
                    this.cover.duration
                )} seconds`;
            case "ai":
                return "AI Word Art";
            case "stock":
                return "Stock Word Art";
        }
    }

    private getHeart(token: string) {
        switch (token) {
            case "violet":
                return "💜";
            case "indigo":
                return "🩷";
            case "blue":
                return "🩵";
            case "green":
                return "💚";
            case "yellow":
                return "💛";
            case "orange":
                return "🧡";
            case "red":
                return "❤️";
            default:
                return "💛";
        }
    }

    // thank
    async tip(miner: any, note: string) {
        const tip = getTipAmount(
            "tip",
            true,
            false,
            true,
            miner,
            this.me.getName2(miner),
            "gold",
            note.split(" ").length, //undefined,
            false,
            false
        );

        if (tip > 0) {
            this.renderStock();
            const response = await this.tokens.give(
                miner.id,
                true,
                "gold",
                note,
                this.stockImage.src, // always stock photo: later ai created
                "", // no short
                0, // no duration
                "stock",
                tip
            );
            if (response.data) {
                await this.functions.push(response.data.id!);
                this.thank = response.data;
                await this.alertSuccess(
                    "",
                    //response.data.isAnonymous,
                    false,
                    //response.data.kiitos!,
                    response.data.fromBalance || 0,
                    response.data.toBalance || 0
                    //response.data.tip,
                    //response.data.pool!
                );

                // const event = new CustomEvent("hb-treasury", {
                //     detail: {
                //         isShow: false
                //     },
                //     bubbles: true,
                //     composed: true
                // });
                // this.dispatchEvent(event);

                window.location.href =
                    window.location.origin + `#/token/${response.data.id}`;
            } else if (response.color === "red") {
                alert(response.text);
                window.location.href = window.location.origin;
            } else window.location.href = window.location.origin;
        } else window.location.href = window.location.origin;
    }

    // uid = to if not gram || from if gram
    async show(
        id: string | Token,
        uid: string,
        isTap: string,
        isBank: boolean
    ) {
        this.showLoading(true);

        if (typeof id === "string" && this.rainbow.includes(id) && uid) {
            if (this.heartbank.user?.uid === uid) {
                window.location.hash = "#";
                this.showLoading(false);
                return;
            }

            this.isChest = false;
            this.isGram = false;
            const profile = await this.me.getUserProfile(uid);

            this.heartTitle.value = id;
            this.heartTitle.disabled = false;
            this.heartMenu.textContent = this.getHeart(id);
            this.heartLabel.textContent = this.getHeart(id);

            if (profile) {
                if (profile.isBroadcast) {
                    this.token = id;
                    this.toUID = uid;
                    this.isBank = isBank;

                    this.date.classList.add("hidden");
                    this.menu.classList.remove("hidden");
                    this.archive.classList.remove("hidden");
                    this.anonymousContainer.classList.remove("hidden");
                    this.anonymousContainer.classList.add("inline-flex");

                    if (this.isBank || isTap === "1") {
                        this.anonymousBtn.click(); // order is important
                        //this.anonymousBtn.disabled = true;
                        //this.publicBtn.disabled = true;
                    } else {
                        //this.anonymousBtn.disabled = false;
                        //this.publicBtn.disabled = false;
                        this.publicBtn.click(); // order is important
                    }

                    this.from.innerHTML = `<hb-me class="ml-0" uid="${this.heartbank.user?.uid || ""}"></hb-me>`;
                    this.to.innerHTML = `<hb-me class="ml-0" uid="${uid}"></hb-me>`;

                    const photo = localStorage.getItem("token-photo");
                    if (photo) {
                        this.photoImage.src = photo;
                        this.photoImageContainer.classList.remove("hidden");
                        this.photoUpload.classList.add("hidden");
                    } else {
                        this.photoImage.removeAttribute("src");
                    }

                    const poster = localStorage.getItem("token-poster");
                    const short = localStorage.getItem("token-short");
                    if (poster || short) {
                        if (poster) this.shortVideo.poster = poster;
                        if (short) this.shortVideo.src = short;
                        this.shortVideo.controls = true;
                        this.shortVideoContainer.classList.remove("hidden");
                        this.shortUpload.classList.add("hidden");
                    } else {
                        this.shortVideo.removeAttribute("poster");
                        this.shortVideo.removeAttribute("src");
                    }

                    this.renderStock(); // needed bc stock is default cover // random stock photo
                    this.stockBtn.click();
                    this.cover.classList.add("hidden");

                    this.goldMenu.classList.remove("hidden");
                    this.goldMenu.classList.add("inline-flex");
                    this.goldLabel.classList.add("hidden");
                    this.goldLabel.classList.remove("inline-flex");

                    const profile = await this.me.getUserProfile(this.toUID);
                    const name = this.me.getName2(profile);

                    this.gold.value = localStorage.getItem("token-gold") || "";
                    // this.gold.placeholder = `Optional: Include some facts here then tap on the Wand Icon for Miss Aquarius™ AI to compose a Thank You Note for ${name} on your behalf\n\nThis Gold will be publicly stored forever on the Aquarius™ Blockchain`;
                    this.gold.placeholder =
                        "Optional: Include a Gratitude Note here for Miss Aquarius™ AI to weigh\n\nYour Gold will be publicly stored forever on the Aquarius™ Blockchain"; // based on context and effort
                    this.gold.disabled = false;
                    this.gold.classList.remove(
                        "text-center",
                        "leading-loose",
                        "font-cursive",
                        "text-2xl",
                        "h-56"
                    );
                    this.gold.classList.add("text-lg", "h-40");

                    this.footer.classList.add("hidden");
                    this.footer.classList.remove("flex");
                    this.internalBtns.classList.remove("hidden");
                    //this.giveBtn.classList.remove("hidden");
                    this.thankBtn.classList.add("hidden");
                    this.rethankBtn.classList.add("hidden");
                    this.thankallBtn.classList.add("hidden");
                    this.externalBtns.classList.add("hidden");
                    this.tokenBtns.classList.add("hidden");
                    this.giveBtn.innerHTML = "Give B-Token of Appreciation";

                    if (isTap === "1") {
                        if (this.heartbank.user && this.hasPasskey) {
                            const tip = isTip()
                                ? getTipAmount(
                                      "tip",
                                      false, // required tip
                                      false,
                                      this.isAnonymous,
                                      profile,
                                      name,
                                      this.token,
                                      this.gold.value.split(" ").length, //undefined,
                                      false
                                  )
                                : 0; // secret feature: can quickly tip or just thank

                            if (tip === -1) {
                                window.location.hash = "#";
                            } else {
                                const response = await this.tokens.give(
                                    this.toUID,
                                    !!tip, // this.isAnonymous,
                                    this.token,
                                    "", // no note
                                    this.stockImage.src, // always stock photo: later ai created
                                    "", // no short
                                    0, // no duration
                                    "stock",
                                    tip
                                );
                                if (response.data) {
                                    await this.functions.push(
                                        response.data.id!
                                    );
                                    this.thank = response.data;
                                    await this.alertSuccess(
                                        "",
                                        //response.data.isAnonymous,
                                        false,
                                        //response.data.kiitos!,
                                        response.data.fromBalance || 0,
                                        response.data.toBalance || 0
                                        //response.data.tip,
                                        //response.data.pool!
                                    );

                                    const event = new CustomEvent(
                                        "hb-treasury",
                                        {
                                            detail: {
                                                isShow: false
                                            },
                                            bubbles: true,
                                            composed: true
                                        }
                                    );
                                    this.dispatchEvent(event);

                                    window.location.hash = `#/token/${response.data.id}`;
                                } else if (response.color === "red") {
                                    alert(response.text);
                                    window.location.hash = "#";
                                } else window.location.hash = "#";
                            }
                        } else {
                            if (this.heartbank.user) {
                                if (
                                    confirm(
                                        "Passkey is required to give this B-Token of Appreciation.\n\nWould you like to create one now?"
                                    )
                                ) {
                                    localStorage.setItem(
                                        "redirect-lockbox",
                                        window.location.hash
                                    );
                                    window.location.hash = "#/lockbox";
                                } else window.location.hash = "#";
                            } else {
                                if (
                                    confirm(
                                        "You need to be logged in to give this B-Token of Appreciation.\n\nWould you like to log in now?"
                                    )
                                ) {
                                    localStorage.setItem(
                                        "redirect-login",
                                        window.location.hash
                                    );
                                    window.location.hash = "#/login";
                                } else window.location.hash = "#";
                            }
                        }
                    } else {
                        this.thank = null;
                        //this.photoBtn.click();
                        this.shortBtn.click();
                        this.modal.show();
                    }
                } else window.location.hash = "#";
            } else window.location.hash = "#";
        } else if (id) {
            this.isGram = uid === "gram";
            this.isChest = uid === "chest";
            this.heartTitle.value = "yellow";
            this.heartTitle.disabled = true;
            this.heartMenu.textContent = this.getHeart("");
            this.heartLabel.textContent = this.getHeart("");

            if (typeof id === "string") {
                const token = await this.tokens.get(id);
                this.thank = token.data;
                if (token.cursor) window.tokenCursor = token.cursor;
            } else {
                this.thank = id;
            }

            if (this.thank) {
                const views = this.views.parentElement
                    ?.lastElementChild as HTMLSpanElement;
                const digs = this.thank.digs || 0;
                const scans = this.thank.scans || 0;
                this.views.textContent = (digs + scans).toString();
                views.textContent =
                    "View" + (this.views.textContent === "1" ? "" : "s");

                this.date.classList.remove("hidden");
                this.menu.classList.add("hidden");
                this.archive.classList.add("hidden");
                this.anonymousContainer.classList.add("hidden");
                this.anonymousContainer.classList.remove("inline-flex");

                const anonName = this.anonymous
                    .lastElementChild as HTMLSpanElement;
                if (this.thank.isAnonymous) {
                    this.from.classList.add("hidden");
                    this.anonymous.classList.remove("hidden");
                    // anonName.textContent =
                    //     this.heartbank.user?.uid === this.thank.from
                    //         ? "YOU as Someone"
                    //         : "Someone";
                } else {
                    this.from.innerHTML = `<hb-me class="ml-0" uid="${this.thank.from}"></hb-me>`;
                    this.from.classList.remove("hidden");
                    this.anonymous.classList.add("hidden");
                    // anonName.textContent = "Someone";
                }
                this.to.innerHTML = `<hb-me class="ml-0" uid="${this.thank.to}"></hb-me>`;

                this.resetMenu();
                this.cover.muted = !this.cover.poster; // needed to allow autoplay
                this.cover.poster = this.thank.jewel;
                if (this.thank.diamond) {
                    this.cover.src = this.thank.diamond;
                    this.cover.controls = true;
                    this.cover.play();

                    this.cover.classList.remove("no-play-button");
                    this.cover.removeAttribute("controlsList");
                    this.cover.style.pointerEvents = "";
                    this.cover.onclick = () => {};
                } else {
                    this.cover.removeAttribute("src");
                    this.cover.controls = false;
                    this.cover.load(); // needed to clear previous video

                    this.cover.classList.add("no-play-button");
                    this.cover.setAttribute(
                        "controlsList",
                        "nodownload nofullscreen noremoteplayback"
                    );
                    this.cover.style.pointerEvents = "none";
                    this.cover.onclick = () => this.cover.pause();
                }
                this.cover.classList.remove("hidden");

                this.goldMenu.classList.add("hidden");
                this.goldMenu.classList.remove("inline-flex");
                this.goldLabel.classList.remove("hidden");
                this.goldLabel.classList.add("inline-flex");
                this.goldKiitos.textContent =
                    this.thank.kiitos?.toString() || "0";

                const goldTitle = this.goldLabel
                    .firstElementChild as HTMLSpanElement;
                goldTitle.onclick = () => {
                    const kiitos =
                        (this.thank?.kiitos || 0) -
                        (this.thank?.rekiitos?.reduce((t, i) => t + i) || 0);
                    alert(
                        `♒️ Miss Aquarius™ AI impartially weighs each B-Token for depth of gratitude and act of kindness and this one equals ${kiitos} Kiitos`
                    );
                };

                const fromName = this.thank.isAnonymous
                    ? this.heartbank.user?.uid === this.thank.from!
                        ? "YOU as Anonymous Thanker"
                        : "Anonymous Thanker" // Content Creator
                    : await this.me.getName3(this.thank.from!);
                const toName = await this.me.getName3(this.thank.to!);

                const gold = this.goldKiitos.parentElement as HTMLSpanElement;
                gold.onclick = () => {
                    let fromTotal = 0,
                        toTotal = 0;
                    if (this.thank?.rekiitos)
                        for (const [
                            index,
                            kiitos
                        ] of this.thank.rekiitos.entries()) {
                            if (this.thank?.isthanks?.[index])
                                fromTotal += kiitos;
                            else toTotal += kiitos;
                        }
                    toTotal +=
                        (this.thank?.kiitos || 0) - (fromTotal + toTotal); // original kiitos

                    alert(
                        `💛 ${fromName} received ${fromTotal} Kiitos in total\n\n💛 ${toName} received ${toTotal} Kiitos in total`
                    );
                };

                const total =
                    this.thank.tip +
                    (this.thank.jar || 0) +
                    (this.thank.kitty || 0) +
                    (this.thank.pool || 0);
                const gratuity = this.goldGratuity
                    .parentElement as HTMLSpanElement;
                gratuity.classList.toggle("hidden", !total);
                this.goldGratuity.textContent = total.toCashAmount();
                gratuity.onclick = () =>
                    alert(
                        `💰 ${fromName}'s Retip B-Fund collected ${(this.thank?.kitty || 0).toCashAmount3()} in total donations\n\n🧧 ${toName}'s Personal B-Account collected ${(this.thank?.tip || 0).toCashAmount3()} in total tips\n\n💰 ${toName}'s Retip B-Fund collected ${(this.thank?.jar || 0).toCashAmount3()} in total gratuities\n\n♒️ Your Family B-Kitty collected ${(this.thank?.pool || 0).toCashAmount3()} in total contributions`
                    );

                const name = this.thank.isAnonymous
                    ? "Someone nearby"
                    : (await this.me.getName3(this.thank.from!)) +
                      " who's nearby";
                this.gold.value = this.thank.gold;
                this.gold.placeholder = `${name} would like to thank you!`; //${toName}
                this.gold.disabled = true;
                this.gold.classList.add(
                    "text-center",
                    "leading-loose",
                    "font-cursive",
                    "text-2xl",
                    "h-56"
                );
                this.gold.classList.remove("text-lg", "h-40");

                this.footerDate.textContent =
                    "Given nearby on " +
                    this.thank.date?.toDate().toFormattedString();
                this.footer.classList.remove("hidden");
                this.footer.classList.add("flex");

                this.goldKarat.textContent =
                    this.thank.karat?.toString() || "0";
                const karat = this.goldKarat.parentElement as HTMLSpanElement;
                karat.onclick = () =>
                    alert(
                        `💛 This B-Token of Appreciation has ${
                            this.goldKarat.textContent
                        } word${
                            this.goldKarat.textContent === "1" ? "" : "s"
                        } in total`
                    );

                this.goldCarat.textContent =
                    this.thank.carat?.toString() || "0";
                const carat = this.goldCarat.parentElement as HTMLSpanElement;
                carat.onclick = () =>
                    alert(
                        `💛 This B-Token of Appreciation has a ${this.getCarat()}`
                    );

                this.rethanks.textContent =
                    this.thank.rethankers?.length.toString() || "0";
                const rethanks = this.rethanks.parentElement as HTMLSpanElement;
                const rethanksText =
                    rethanks.lastElementChild as HTMLSpanElement;
                rethanksText.textContent =
                    "Re-thank" + (this.rethanks.textContent === "1" ? "" : "s");
                rethanks.onclick = async () => {
                    rethanks.style.opacity = "0.5";
                    let text = "";

                    if (
                        this.thank?.rethankers &&
                        this.thank.rethankers.length > 0
                    ) {
                        for (const [
                            index,
                            uid
                        ] of this.thank.rethankers.entries()) {
                            const isThank =
                                this.thank.isthanks?.[index] || false;
                            const tip = this.thank.retips?.[index] || 0;
                            const pool = this.thank.repools?.[index] || 0;

                            const minter = await this.me.getUserProfile(uid);
                            const minterName = tip
                                ? this.heartbank.user?.uid === uid
                                    ? "YOU as Someone"
                                    : "Someone"
                                : this.me.getName2(minter);
                            const [minterSign, minterKarat] =
                                minter.kiitos.numberTuple() || ["", "Zero"];

                            const minerID = isThank
                                ? this.thank.from!
                                : this.thank.to;
                            const miner = await this.me.getUserProfile(minerID);
                            const minerName =
                                isThank && this.thank.isAnonymous
                                    ? this.heartbank.user?.uid === minerID
                                        ? "YOU as Anonymous Thanker"
                                        : "Anonymous Thanker"
                                    : this.me.getName2(miner);
                            const [minerSign, minerKarat] =
                                miner.kiitos.numberTuple() || ["", "Zero"];

                            const gratuity = tip
                                ? ` and ${isThank ? "donated" : "tipped"} ${tip.toCashAmount3()}${!isThank && pool ? ` and donated ${pool.toCashAmount3()}` : ""} to ${minerName}` +
                                  (isThank && pool
                                      ? ` and contributed ${pool.toCashAmount3()} to your Family B-Kitty`
                                      : "")
                                : ` to ${minerName}`;

                            text += `\n\n🟨 ${minterName} who's nearby re-gave ${this.thank.rekiitos?.[index]} Kiitos${gratuity} on ${this.thank.redates?.[index].toDate().toFormattedString()}\n\n${getCircle(
                                minter.kiitos || 0,
                                true
                            )} ${minterName}'s current Kiitos Balance is ${minterSign + minterKarat} ${getKiitosSummary(minter.kiitos || 0, minterName)}\n\n${getCircle(
                                miner.kiitos || 0,
                                true
                            )} ${minerName}'s current Kiitos Balance is ${minerSign + minerKarat} ${getKiitosSummary(miner.kiitos || 0, minerName)}`;
                        }
                    }

                    const total = this.thank?.rethankers?.length || 0;
                    alert(
                        total
                            ? `💛 This B-Token of Appreciation has ${total} Nearby Re-Thanker${total === 1 ? "" : "s"}:${text}`
                            : `💛 This B-Token of Appreciation has no Nearby Re-Thankers for ${fromName} or ${toName}`
                    );
                    rethanks.style.opacity = "";
                };

                const [hasThank, hasReThank] = this.checkThank();
                const showThank =
                    !this.heartbank.user ||
                    (this.thank.from !== this.heartbank.user.uid && !hasThank); // !this.thank.isAnonymous                      //this.thank.to !== this.heartbank.user.uid && !this.thank.isAnonymous &&
                const showReThank =
                    !this.heartbank.user ||
                    (this.thank.to !== this.heartbank.user.uid && !hasReThank);

                this.internalBtns.classList.remove("hidden");
                //this.giveBtn.classList.toggle("hidden", !!showReThank);
                this.thankBtn.classList.toggle("hidden", !showThank);
                this.rethankBtn.classList.toggle("hidden", !showReThank);
                this.thankallBtn.classList.toggle(
                    "hidden",
                    !(showThank && showReThank)
                );
                this.externalBtns.classList.remove("hidden");
                this.tokenBtns.classList.add("hidden");
                this.giveBtn.innerHTML =
                    "Give <strong>New</strong> B-Token of Appreciation";
                this.thankBtn.innerHTML = `Thank <strong>${this.thank.isAnonymous ? "Anonymous Thanker" : await this.me.getName3(this.thank.from!)}</strong>`;
                this.rethankBtn.innerHTML = `Re-Thank <strong>${await this.me.getName3(this.thank.to!)}</strong>`;
                // if (this.tokenBtns.childElementCount === 0)
                //     await this.renderTokens();

                // stats
                this.tokens.addMiner(
                    this.heartbank.user?.uid || "",
                    this.thank.id!
                ); // await
                this.modal.show();
            } else window.location.hash = "#";
        } else window.location.hash = "#";

        this.showLoading(false);
    }

    // not used
    private getName(
        uid: string,
        name: string,
        isAnonymous: boolean,
        isThanker: boolean
    ) {
        if (isAnonymous) {
            return this.heartbank.user?.uid === uid
                ? `YOU as ${isThanker ? "Anonymous Thanker" : "Someone"}`
                : "Someone";
        } else return name;
    }

    private checkThank(): [boolean, boolean] {
        let hasThank = false;
        let hasReThank = false;

        if (this.thank?.rethankers) {
            for (const [index, rethanker] of this.thank.rethankers.entries()) {
                if (rethanker === this.heartbank.user?.uid) {
                    if (this.thank.isthanks?.[index]) hasThank = true;
                    else hasReThank = true;
                }
            }
        }

        // original tip
        const tip =
            (this.thank?.tip || 0) +
            (this.thank?.jar || 0) +
            (this.thank?.kitty || 0) +
            (this.thank?.pool || 0) -
            (this.thank?.retips?.reduce((t, i) => t + i) || 0) -
            (this.thank?.repools?.reduce((t, i) => t + i) || 0);

        return [
            hasThank,
            this.thank?.from === this.heartbank.user?.uid && tip
                ? true
                : hasReThank
        ];
    }

    hide() {
        this.modal.hide();
    }

    private async renderTokens(uid: string, isThank: boolean | null) {
        const isThankAll = isThank === null;

        const isSenderReThank = this.heartbank.user?.uid === this.thank?.from; // && this.heartbank.user?.uid !== uid;
        this.tokenBtns.innerHTML = "";

        // cancel
        const button = document.createElement("button");
        button.type = "button";
        button.className = `text-white bg-yellow-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
        button.innerHTML = `Cancel`;
        button.onclick = () => {
            this.externalBtns.classList.remove("hidden");
            this.internalBtns.classList.remove("hidden");
            this.tokenBtns.classList.add("hidden");
        };
        this.tokenBtns.appendChild(button);

        const profile = await this.me.getUserProfile(uid);
        const name = isThankAll
            ? "ALL"
            : isThank && this.thank?.isAnonymous
              ? "Anonymous Thanker"
              : this.me.getName2(profile);
        //const name = await this.me.getName3(uid);
        const names = isThankAll
            ? `${this.thank?.isAnonymous ? "Anonymous Thanker" : await this.me.getName3(this.thank?.from!)} and ${await this.me.getName3(this.thank?.to!)}`
            : "";

        for (const token of TOKENS) {
            const button = document.createElement("button");
            button.type = "button";
            //button.dataset.token = token.token;
            button.className = `text-white ${token.color} focus:ring-4 focus:outline-none font-medium rounded-lg text-base w-full px-5 py-2.5 text-center`;
            button.innerHTML = `Give ${token.emoji} ${isSenderReThank ? "B-Tip" : "Kiitos"} to <strong>${name}</strong>`; //B-Token

            button.onclick = async () => {
                this.showLoading(true);
                button.disabled = true;
                if (this.heartbank.user && this.hasPasskey) {
                    const tip = isSenderReThank
                        ? getTipAmount(
                              "retip",
                              true,
                              isThank,
                              true,
                              profile,
                              names || name,
                              token.token,
                              this.thank?.kiitos || 0,
                              true,
                              false
                          )
                        : getTipAmount2(
                              isThank,
                              true,
                              profile,
                              names || name,
                              token.token,
                              this.thank?.kiitos || 0
                          );

                    if (!isSenderReThank || tip > 0) {
                        const response = await this.tokens.rethank(
                            isThankAll ? null : this.thank?.from === uid,
                            this.thank?.id!,
                            token.token,
                            tip
                        );
                        if (response.data) {
                            const index = response.data.rethankers!.lastIndexOf(
                                this.heartbank.user.uid
                            );
                            const kiitos = response.data.rekiitos![index];
                            const tip = response.data.retips![index];
                            const pool = response.data.repools![index];

                            //this.toUID = response.data.to;
                            //this.isAnonymous = response.data.isAnonymous;
                            this.thank = response.data;
                            this.thank.kiitos = isThankAll
                                ? kiitos * 2
                                : kiitos;
                            this.thank.tip = isThankAll
                                ? tip
                                : isThank
                                  ? 0
                                  : tip;
                            this.thank.jar = isThankAll
                                ? pool
                                : isThank
                                  ? 0
                                  : pool;
                            this.thank.kitty = isThankAll
                                ? tip
                                : isThank
                                  ? tip
                                  : 0;
                            this.thank.pool = isThankAll
                                ? pool
                                : isThank
                                  ? pool
                                  : 0;

                            await this.alertSuccess(
                                isThankAll
                                    ? ""
                                    : this.thank?.from === uid
                                      ? uid
                                      : "",
                                //response.data.isAnonymous,
                                true,
                                //isThankAll ? kiitos * 2 : kiitos,
                                response.data.fromBalance || 0,
                                response.data.toBalance || 0,
                                //isThankAll ? tip * 2 : tip,
                                //isThankAll ? pool * 2 : pool,
                                isThankAll
                                    ? response.data.thankerBalance
                                    : undefined
                            );

                            const event = new CustomEvent("hb-treasury", {
                                detail: {
                                    isShow: false
                                },
                                bubbles: true,
                                composed: true
                            });
                            this.dispatchEvent(event);

                            await this.show(response.data.id!, "", "", true);
                        } else if (response.color === "red")
                            alert(response.text);
                    }
                } else {
                    if (this.heartbank.user) {
                        if (
                            confirm(
                                `Passkey is required to re-thank ${name}\n\nWould you like to create one now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-lockbox",
                                window.location.hash
                            );
                            window.location.hash = "#/lockbox";
                        }
                    } else {
                        if (
                            confirm(
                                `You need to be logged in to re-thank ${name}\n\nWould you like to log in now?`
                            )
                        ) {
                            localStorage.setItem(
                                "redirect-login",
                                window.location.hash
                            );
                            window.location.hash = "#/login";
                        }
                    }
                }
                button.disabled = false;
                this.showLoading(false);
            };

            this.tokenBtns.appendChild(button);
        }
    }

    private renderStock() {
        const item = this.page.firstElementChild as HTMLSpanElement;
        const total = this.page.lastElementChild as HTMLSpanElement;
        //console.log(this.stockCategory, this.stockItem, this.stockCount);

        item.textContent = this.stockItem.toString();
        total.textContent = this.stockCount.toString();

        this.stockImage.src = `${TREASURY}/${this.stockCategory}/${this.stockItem}/${this.stockItem}.gif`;
    }

    private goToAI(direction: boolean) {}

    private async goToStock(direction: boolean) {
        if (direction) {
            if (this.stockItem < this.stockCount) {
                ++this.stockItem;
            } else {
                this.stockItem = 1;
            }
        } else {
            if (this.stockItem > 1) {
                --this.stockItem;
            } else {
                this.stockItem = this.stockCount;
            }
        }

        this.renderStock();
    }

    private getUrl() {
        return `${B}/t/${this.thank!.id}`;
    }

    private async getText(isShare: boolean) {
        if (this.thank?.rethankers && this.thank.rethankers.length > 0)
            return "";
        else {
            const name = await this.me.getName3(this.thank?.to!);
            const header = "💛 HeartBank® Token of Appreciation\n\n";
            const footer = `💝 If ${name}'s kindness moves your heart too, tap on the link to re-thank ${name}!`;
            //"♒️ Tap on the link if you want to play the Zero-Point Game ℠ by Miss Aquarius™ AI too!";

            const gold = this.thank?.gold ? this.thank.gold + "\n\n" : "";
            const url = isShare ? "" : this.getUrl() + "\n\n";
            const url2 = isShare ? "" : this.getUrl();

            return header + gold + url + footer;
            //return gold ? header + gold + url + footer : url2;
        }
    }

    private async share(event: Event) {
        event.preventDefault();
        this.shareBtn.disabled = true;

        const shareData = {
            title: "HeartBank® Token",
            text: await this.getText(true),
            url: this.getUrl(),
            files: []
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error: any) {
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    console.warn("Sharing was cancelled:", error);
                } else {
                    console.error(error);
                }
            }
        } else {
            alert("Sorry, Web Share is not supported on this device.");
        }

        this.shareBtn.disabled = false;
    }
}
